<template>
  <div id="zhuanti_icon" class="channel_name">
    <van-tag type="primary" size="large" color="#f43f44">{{ title }}</van-tag>
    <van-tag v-if="title === '预告'" type="primary" size="large" color="#f43f44" class="begintostart">
      直播倒计时：
      <van-count-down :time="time" :format="format" @finish="beginLive" />
    </van-tag>

    <van-tag
      type="primary"
      class="begintostart"
      size="large"
      color="#f43f44"
      v-if="state == 'ing' || state == 'end'"
    >{{ lookNum }}人观看</van-tag>
  </div>
</template>



<script>
import { tranNumber } from "../util/helper"

export default {
  props: ["info", "state"],
  methods: {
    beginLive() {
      this.$emit('begin-live')
    }
  },
  computed: {
    title() {
      switch (this.state) {
        case "preWithIMG":
        case "preWithVideo":
          return "预告";
        case "ing":
          return "直播中";
        case "end":
          return "回放";

        default:
          return "直播";
      }
    },
    time() {
      return this.info.beginTime - Date.parse(new Date());
    },
    format() {
      // 时间差
      const diff = this.info.beginTime - Date.parse(new Date());
      console.log("diff", diff);
      // 一天秒数
      const DAY = 60 * 60 * 24 * 1000;
      // 一小时秒数
      const HOUR = 60 * 60 * 1000;

      if (diff > DAY) {
        return "DD 天 HH 时 mm 分 ss 秒";
      } else if (diff > HOUR) {
        return "HH 时 mm 分 ss 秒";
      } else {
        return "mm 分 ss 秒";
      }
    },

    lookNum() {
      return tranNumber(this.info.clickNum,1);
    }
  },
};
</script>



<style scoped>
.begintostart {
  margin-left: 0.2rem;
}

.van-count-down {
  color: #fff;
}
</style>